import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'parental-student-attendance-daily'
const initialState = {
  list: null,
}

export const search = createApiAction(
  'academic/parental-student-attendance-daily/search',
  client.search('/api/academic/parent/student/:studentId/attendance/daily'),
)

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(search.fulfilled, (state, action) => {
      state.list = action.payload
    })
  },
})

export default sessionSlice.reducer